import { createApiActionTypes } from '../../helpers/actions';

export const APP_LOGIN = createApiActionTypes('APP_LOGIN');

export const APP_SET_THEME = 'APP_SET_THEME';
export const APP_SET_IS_READY = 'APP_SET_IS_READY';
export const APP_SET_SESSION_ID = 'APP_SET_SESSION_ID';



// WEBPACK FOOTER //
// ./src/actions/app/types.js